import { ParameterService } from 'services/ParametersProviderApi/ParametersService';

export class ChatTracking {
  private static instance: ChatTracking;

  public static getInstance(): ChatTracking {
    if (!ChatTracking.instance) {
      ChatTracking.instance = new ChatTracking();
    }
    return ChatTracking.instance;
  }

  public trackWoopraEvent(eventName: string, properties: Record<string, any> = {}): void {
    const dynamicParameters = ParameterService.getParameters();
    if (dynamicParameters.WOOPRA_DOMAIN) {
      try {
        // @ts-ignore
        window.woopra && window.woopra.track(eventName, {
          ...properties,
          timestamp: new Date().toISOString(),
          page: 'pure-ai',
        });
        console.log('trackWoopraEvent success');
      } catch (error) {
        console.warn('Failed to track Woopra event:', error);
      }
    }
  }


  public trackHotjarEvent(eventName: string, properties: Record<string, any> = {}): void {
    const dynamicParameters = ParameterService.getParameters();
    if (dynamicParameters.HOTJAR_APP_ID) {
      try {
        // @ts-ignore
        window.hj && window.hj('event', eventName, properties);
      } catch (error) {
        console.warn('Failed to track Hotjar event:', error);
      }
    }
  }

  public trackNewChat(): void {
    this.trackHotjarEvent('chat_new_chat');
  }

  public trackEditName(chatId: string, oldName: string, newName: string): void {
    this.trackHotjarEvent('chat_edit_name', {
      chatId,
      oldName,
      newName
    });
  }


  public trackDeleteChat(chatId: string, chatName: string): void {
    this.trackHotjarEvent('chat_delete', {
      chatId,
      chatName
    });
  }


  public trackPinChat(chatId: string, chatName: string, isPinned: boolean): void {
    this.trackHotjarEvent('chat_pin', {
      chatId,
      chatName,
      isPinned
    });
  }


  public trackDownloadChat(chatId: string, chatName: string): void {
    this.trackHotjarEvent('chat_download', {
      chatId,
      chatName
    });
  }


  public trackSearch(query: string, resultsCount: number = 0): void {
    this.trackHotjarEvent('chat_search', {
      query,
      resultsCount
    });
  }


  public trackCategoryClick(categoryId: string, categoryName: string): void {
    this.trackHotjarEvent('chat_category_click', {
      categoryId,
      categoryName
    });
  }


  public trackPromptClick(prompt: string, categoryId?: string, categoryName?: string): void {
    this.trackHotjarEvent('chat_prompt_click', {
      prompt,
      categoryId,
      categoryName
    });
  }


  public trackChatSelection(chatId: string, chatName: string): void {
    this.trackHotjarEvent('chat_selection', {
      chatId,
      chatName
    });
  }


  public trackPageView(): void {
    this.trackHotjarEvent('chat_page_view', {
      timestamp: new Date().toISOString()
    });
  }
}

export const chatTracking = ChatTracking.getInstance();


